import { render, staticRenderFns } from "./Svg.vue?vue&type=template&id=12b4cf13&scoped=true&"
import script from "./Svg.vue?vue&type=script&lang=js&"
export * from "./Svg.vue?vue&type=script&lang=js&"
import style0 from "./Svg.vue?vue&type=style&index=0&id=12b4cf13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4cf13",
  null
  
)

export default component.exports